import script from "./StatisticsList.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsList.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsList.vue?vue&type=style&index=0&id=d90a7d82&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d90a7d82"]])

export default __exports__